import { render, staticRenderFns } from "./ViewReturns.vue?vue&type=template&id=49ce7844"
import script from "./ViewReturns.vue?vue&type=script&lang=js"
export * from "./ViewReturns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports